import { format } from "date-fns"
import { cn } from "@/lib/utils"
import { useSidebar } from "@/components/ui/sidebar"
import DailyCalendarStudyTime from "./daily-calendar-study-time"

interface DailyCalendarHeaderProps {
  mainHeaderIsSticky?: boolean
}

export default function DailyCalendarHeader({
  mainHeaderIsSticky = false,
}: DailyCalendarHeaderProps) {
  const today = new Date()
  const dayName = format(today, "EEEE")
  const dayNumber = format(today, "d")

  const { state } = useSidebar()

  return (
    <div
      data-sidebar-state={state}
      className={cn(
        "flex w-full select-none items-center justify-between px-2",
        mainHeaderIsSticky &&
          "fixed top-[120px] z-40 border-b border-gray-200 bg-white px-8 py-4 shadow-sm",
        mainHeaderIsSticky && state === "expanded" && "left-64 w-[calc(100%-16rem)]",
        mainHeaderIsSticky && state === "collapsed" && "left-[72px] w-[calc(100%-72px)]",
        !mainHeaderIsSticky && "w-full",
      )}
    >
      <div className="flex items-center justify-center gap-2">
        <span className="text-sm capitalize text-gray-800">{dayName}</span>
        <span className="flex size-8 items-center justify-center rounded-full bg-primary p-2 text-sm font-semibold text-white">
          {dayNumber}
        </span>
      </div>

      <DailyCalendarStudyTime />
    </div>
  )
}
